    <mat-card>
        <div class="d-flex align-items-center justify-content-center position-relative">
            <div style="flex: 1; text-align: center;">
                <mat-card-title style="margin: 0;">{{ title }}</mat-card-title>
            </div>
            <button mat-icon-button color="warn" (click)="onButtonClick()" aria-label="Cerrar" >
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <mat-card-content *ngIf="masterRegister">
            <div class="row pt-2">
                <div class="col-12 col-md-4">
                    <strong>N° CDP: </strong>
                    <b>{{ masterRegister?.concecutiveCDP }}</b>
                </div>
                <div class="col-12 col-md-4 pt-2">
                    <strong>N° RCP: </strong>
                    <b>{{ masterRegister?.consecutive }}</b>
                </div>
                <div class="col-12 col-md-4 pt-2">
                    <strong>Valor Registro: </strong>
                    <b>{{ masterRegister?.value | currency }}</b>
                </div>
                <div class="col-12 pt-2">
                    <strong>Objeto: </strong>
                    <b>{{ masterRegister?.object }}</b>
                </div>
            </div>
        </mat-card-content>
  </mat-card>
      
  <mat-card>
  <mat-card-title>{{ listTitle }}</mat-card-title>

    <ng-container *ngIf="listOrders && listOrders.length; else loading">
      <div *ngFor="let order of listOrders" class="d-flex align-items-center mb-3">
        <button *ngIf="order.value > 0 || order.value < 0" mat-mini-fab color="primary" (click)="openForm(order.id)" matTooltip="Ver detalle">
          <mat-icon>arrow_forward</mat-icon>
        </button>
        <button *ngIf="order.value == 0" mat-mini-fab color="primary" (click)="openForm(order.id)" matTooltip="Ver detalle">
          <mat-icon>done</mat-icon>
        </button>
        <span class="ml-3 font-weight-bold">{{order.minipresu}} - {{order.nombre}}, {{ type == 1 ? 'Orden de Pago' : 'Cuenta por Pagar' }} {{ order.consecutive }}, Saldo disponible: {{ order.value | currency }} </span>
      </div>
    </ng-container>
    <ng-template #loading>
      <mat-spinner></mat-spinner>
        <mat-progress-bar class="col-12" *ngIf="loadingData || !configTable" mode="indeterminate"></mat-progress-bar>
    </ng-template>
  <div class="d-flex justify-content-between">
     <button *ngIf="canGenerateCertificate && !certificateId" mat-raised-button color="primary" (click)="selectResponsible()" matTooltip="Ver detalle">
        Generar Recibido Satisfacción  
      </button>
  </div>
</mat-card>
<mat-card *ngIf="certificateId">
  <app-list  #assets entityName="CertificatesAsset" module="MovimientoBienes"
          group="GV"
          [dataEntity]="{enableAdd: false, customTitle: 'Acta Recibido Satisfacción', exportableDocs:false, group: 'GA', displayGroup: 'GV'}"
          [defaultQuery]="[{column:'id', value: certificateId }, {column:'certificateType', value: ['IP'] }, {column:'dateAnnulment', value: false }]">
  </app-list>
</mat-card>

